// extracted by mini-css-extract-plugin
export default {"blue-progress":"progressicon_blue-progress__CVdcj"};